import { useQuery } from '@tanstack/react-query';

import { useApi } from '@sbv-clients/data-access-api';
import { UnwrapArray } from '@sbv-clients/util-misc';

export enum FacilityCacheKeys {
  FacilityMenu = 'facility-menu',
}

export const useFacilityMenuGet = () => {
  // if (process.env.NX_TA_DEV) {
  //   return menuItems;
  // }

  const api = useApi();
  return useQuery({
    queryKey: [FacilityCacheKeys.FacilityMenu],
    queryFn: async () => {
      try {
        const response = await api.facilityApi.facilityMenuGet({});
        return response.data ?? [];
      } catch {
        return [];
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export type FacilityMenuResponseType = NonNullable<
  UnwrapArray<ReturnType<typeof useFacilityMenuGet>['data']>
>;
